<template>
  <div class="home">
    <div>
      <div id="banner">
        <Banner ref="banner" />
      </div>
      <div id="price">
        <Price ref="price" />
      </div>

      <div id="effect">
        <Effect ref="effect" />
      </div>

      <div id="gps">
        <Gps ref="gps" />
      </div>

      <div id="about">
        <About ref="about" />
      </div>
    <van-tabbar v-model="active"  @change="onChange">
        <van-tabbar-item replace url="/#price" icon="chat-o">价格</van-tabbar-item>
        <van-tabbar-item icon="gold-coin-o" @click="showPopup">咨询</van-tabbar-item>
        <van-tabbar-item replace url="#effect" icon="photo-o">实拍效果</van-tabbar-item>
        <van-tabbar-item replace url="#about" icon="friends-o">关于我们</van-tabbar-item>
  </van-tabbar>
    </div>

    <van-popup v-model="advisory">
      <img src="../assets/qrcode_for_gh_6f36dbdb76b5_258.jpg" />
      <div class="text-center">
        问题咨询、查看使用指南<br />
        请使用微信扫描以上二维码<br />
        关注微信公众号：中控大师
      </div>
      </van-popup>
  </div>
</template>

<script>
import Banner from "@/components/Banner.vue";
import Price from "@/components/Price.vue";
import Effect from "@/components/Effect.vue";
import Gps from "@/components/Gps.vue";
import About from '@/components/About.vue';

export default {
  name: 'Home',
  components: {
    Banner, Price, Effect, Gps, About,
  },
  data() {
    return {
      advisory: false,
      active: -1,
    };
  },
  methods: {
    showPopup() {
      this.advisory = true;
    },
  },
}
</script>
